export const siteInfo = {
  name: '虚空韩漫网',
  nameEn: 'Void Manhwa',
  tagline: '韩漫在线阅读 — 免费韩国漫画大全',
  description: '虚空韩漫网支持韩漫在线阅读，拥有免费的韩国漫画大全和无删减下拉式韩漫，强大的搜索引擎助您快速定位。每日更新最新最热韩国漫画，为您提供最佳的韩漫阅读体验。',
  url: 'http://0661yes.cn/',
  logo: '虚空韩漫',
  founded: '2020',
  email: 'hello@0661yes.cn',
  phone: '400-888-6666',
  address: '北京市朝阳区望京SOHO T1 1208室',
  wechat: 'xukongmanhua',
  qq: '1234567890',
  stats: {
    totalComics: '50,000+',
    dailyUsers: '200万+',
    monthlyViews: '5亿+',
    totalChapters: '300万+',
  },
};

export const faqData = [
  {
    question: '虚空韩漫网的漫画都是免费的吗？',
    answer: '是的！虚空韩漫网上的所有韩国漫画都完全免费，无需付费即可畅享海量韩漫资源。我们致力于为韩漫爱好者提供最优质的免费阅读体验，每日更新最新最热的韩国漫画。',
  },
  {
    question: '什么是下拉式韩漫？如何阅读？',
    answer: '下拉式韩漫是韩国漫画的特色阅读方式，您只需向下滑动页面即可连续阅读，无需翻页。这种阅读方式更适合手机和电脑端，让您沉浸在流畅的漫画世界中，获得最佳的韩漫在线阅读体验。',
  },
  {
    question: '网站上的漫画多久更新一次？',
    answer: '虚空韩漫网每天都会更新大量最新漫画章节。热门连载作品通常每周更新1-2话，已完结作品可以直接阅读全部章节。您可以关注收藏喜欢的漫画，第一时间获取更新通知。',
  },
  {
    question: '如何搜索我想看的漫画？',
    answer: '您可以使用网站顶部的搜索框，输入漫画名称、作者名或相关关键词进行搜索。我们的搜索引擎支持模糊匹配，即使只记得部分关键词也能快速找到您想要的免费韩国漫画。',
  },
  {
    question: '可以在手机上阅读吗？',
    answer: '当然可以！虚空韩漫网完美适配手机、平板和电脑等各种设备。下拉式韩漫在手机端阅读体验更佳，随时随地畅享韩漫在线阅读。',
  },
  {
    question: '如何联系虚空韩漫网的客服？',
    answer: '您可以通过以下方式联系我们：邮箱 hello@0661yes.cn，电话 400-888-6666，或关注微信公众号「xukongmanhua」。我们的客服团队工作时间为周一至周五 9:00-18:00。',
  },
];